export const addonKey = 'performance';
export const panelKey = 'performance/panel';
export const panelTitle = 'Performance';
export const decoratorKey = 'withPerformance';
export const paramKey = 'performance';
export const packageName = 'storybook-addon-performance';
